
export default {
  API_ENDPOINT: 'https://shielded-depths-44236.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token'
}
//'http://localhost:8000/api'
//